import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';

const cssPrefix = 'search-space';

export namespace SearchSpaceStyles {
  export const Results = cssClass(cssPrefix, 'toolbar', {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XXLarge,
    marginTop: TabStyles.Spacing.MediumSpace,
  });

  export const ResultsDetails = cssClass(cssPrefix, 'results-details', {
    fontWeight: 'normal',
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingBottom: TabStyles.Typography.Sizing.XLarge,
    fontSize: 14,
    color: TabStyles.Typography.Color.PrimaryLight,
    height: 21, // Avoids vertical shifting when switching from spinner to text
    lineHeight: '21px',
    display: 'flex'
  });

  export const ResultsDetailsBold = cssClass(cssPrefix, 'results-details-bold', {
    fontWeight: 'bold',
    paddingRight: CommonStyles.Sizes.DefaultSpace,
    paddingLeft: CommonStyles.Sizes.DefaultSpace
  });

  export const ResultsDetailsSearchTerm = cssClass(cssPrefix, 'results-details-search-term-bold', {
    fontWeight: 'bold'
  });
}
